import { render, staticRenderFns } from "./ItemWriteComponent.vue?vue&type=template&id=63fccc4a&scoped=true"
import script from "./ItemWriteComponent.vue?vue&type=script&lang=js"
export * from "./ItemWriteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fccc4a",
  null
  
)

export default component.exports